import { HttpClinet, baseURL, version } from './../utils/config'

export const settingAPI = {
    GetType: (token) => {
        return HttpClinet({
            url: `${baseURL}/api/${version}/type/GetTypeSetting`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                // console.log(error+' ไอปั้นปิด Services')
                throw error
            })
    },
    GetTemplateSetting: (token) => {
        return HttpClinet({
            url: `${baseURL}/api/${version}/type/GetTemplateSetting`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                // console.log(error+' ไอปั้นปิด Services')
                throw error
            })
    },
    getTypeByID: (token, _id) => {
        return HttpClinet({
            url: `${baseURL}/api/${version}/type/getTypeByID/${_id}`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                // console.log(error+' ไอปั้นปิด Services')
                throw error
            })
    },
    getTemplateByID: (token, _id) => {
        return HttpClinet({
            url: `${baseURL}/api/${version}/type/getTemplateByID/${_id}`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                // console.log(error+' ไอปั้นปิด Services')
                throw error
            })
    },
    DeleteType: (token, _id) => {
        return HttpClinet({
            url: `${baseURL}/api/${version}/type/DeleteType`,
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            data: { _id }
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    DeleteTemplate: (token, _id) => {
        return HttpClinet({
            url: `${baseURL}/api/${version}/type/DeleteTemplate`,
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            data: { _id }
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    AddType: (token, data) => {
        return HttpClinet({
            url: `${baseURL}/api/${version}/type/AddType`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            data: data
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                // console.log(error+' ไอปั้นปิด Services')
                throw error
            })
    },
    AddTemplate: (token, data) => {
        return HttpClinet({
            url: `${baseURL}/api/${version}/type/AddTemplate`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            data: data
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                // console.log(error+' ไอปั้นปิด Services')
                throw error
            })
    },
    EditType: (token, data) => {
        return HttpClinet({
            url: `${baseURL}/api/${version}/type/EditType`,
            method: 'PATCH',
            headers: {
                "Content-Type": "multipart/form-data",
            },
            data: data
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                // console.log(error+' ไอปั้นปิด Services')
                throw error
            })
    },
    EditTemplate: (token, data) => {
        return HttpClinet({
            url: `${baseURL}/api/${version}/type/EditTemplate`,
            method: 'PATCH',
            headers: {
                "Content-Type": "multipart/form-data",
            },
            data: data
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                // console.log(error+' ไอปั้นปิด Services')
                throw error
            })
    },
}